import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { MapControlService } from '../../services/map-control.service';
import { EventLogicService } from '../../services/event-logic.service';
import { Subscription, skip } from 'rxjs';
import * as Highcharts from 'highcharts';
import { trigger, transition, style, animate } from '@angular/animations';
import { EnvironmentService } from '../../services/img-source.service';
import { AfterViewChecked, ChangeDetectorRef } from '@angular/core'
import { DateUtils } from 'src/app/utils/days-utils';
import { isValidCoordinate } from 'src/app/utils/constants';
import { MapGeofenceRendererService } from 'src/app/trip-view/services/map-geofence-renderer.service';
interface MarkerLabel extends google.maps.ReadonlyMarkerLabel {
  labelOrigin: google.maps.Point;
}
@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('500ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
  
})
export class MapViewComponent implements OnInit, OnDestroy,AfterViewChecked {
  @Output() reStart = new EventEmitter<any>();
  @Input() driverData;
  Highcharts: typeof Highcharts = Highcharts;
  driverRes;
  options: any = {
    series: [{ data: [0], dataLabels: {} }],
  };
  
  imgSrc: string;
  speedColor: any = '#F2FBFF';
  driverFixedDevice:boolean = false;
  disabledFixedDeviceToggle:boolean = false;
  noShowInterval: any;
  currentGPSLossData:any
  noShowOnMapMarkers: any=[];
  vehicleArrival: any=[];
  newShuttleStops : any;
  clickedMarker: google.maps.Marker | null = null; // Class-level property
  enableEmployeesDetails:boolean = false;
  selectedShuttleStop: any ; // Store the selected shuttle stop data
  otaOtdData: boolean = false;
  employeeDetails: any;
  callEmployee: any;
  currentDeviceOff: any;
  currentOverSpeedData: any;
  // selectedRadioValue:string = ''

  constructor(
    private envService: EnvironmentService,
    private commonService: CommonService,
    public mapControlService: MapControlService,
    private eventLogicService: EventLogicService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private geofenceRendererService: MapGeofenceRendererService
  ) { }
  tripDetails = this.commonService.response.tripDetails;
  intervalTime: number;

  polyline: google.maps.Polyline;
  map: google.maps.Map | undefined;
  lat;
  lng;
  coordinates: google.maps.LatLng;

  plannedRouteToggle = false;
  planedRoutePath: google.maps.Polyline | undefined;

  vehicleCurrentLocationCords: any;
  formattedWaypoints: any[] = [];
  vehiclePreviousCoords: any;

  locationList: any[];
  vehicleStopageMarker: google.maps.Marker | undefined | null;
  geofenceMarker: google.maps.Circle | undefined | null;

  circleRadius: number;
  circleOpacity: number;

  mapOptions: google.maps.MapOptions;

  vehicleSpeed: number = 0;

  events: Object[];

  chart: any;

  empPickupDropForStops: Map<number, number> = new Map();
  geofenceHittedStops: Map<string, number> = new Map();

  vehicleStoppageIndexes: any[];

  indexForMilestone: number = 0;

  sosArrayRes: any;
  overspeedingIntervals: any;
  isOverspeeding: boolean = false;
  startPlottingOverspeed: boolean = false;
  overspeedformattedWaypoints: google.maps.LatLng[] = [];
  increasing: boolean = true;
  strokeWidth: number = 4;
  maxStrokeWidth: number = 10;
  polylineAnimationList: any[] = [];

  networkLossIntervals: any[];
  startNetworkLoss: boolean = false;
  noInternetAnimation: any;
  busImageURL: string = 'assets/icons/bus-on-map.svg';

  deviceOffIntervals: any[];
  // deviceNotConnectedMarker: google.maps.Marker;
  deviceOffStart: boolean = false;

  gpsLossIntervals: any[];
  gpsLossStart: boolean = false;
  gpsLossWaypoints: google.maps.LatLng[] = [];

  assetPath: Object;
  showOverlay: boolean = false;
  showMapLoader: boolean = false;

  startCallSubscription: Subscription;
  filterChangeSubscription: Subscription;
  mapLoaderSubscription: Subscription;
  restartCallSubscription: Subscription;
  locationListSubscription: Subscription;

  firstTimePlottingMarker: boolean = true;
  firstTripStart: boolean = true;

  eventVisibility: Map<string, boolean> = this.mapControlService.eventVisibility;

  ngOnInit(): void {
    this.driverRes = this.driverData;
    this.driverFixedDevice=this.commonService.driverFixedDevice
    this.disabledFixedDeviceToggle=this.commonService.disabledFixedDeviceToggle;
    this.imgSrc = this.envService.getReplayImgSrc();
    this.busImageURL=this.envService.getReplayImgSrc()+this.busImageURL
    const isOut = this.tripDetails.direction === 'OUT';
    const location = isOut
      ? this.tripDetails.plannedEndLocation
      : this.tripDetails.plannedStartLocation;

    if (location?.geocord) {
      const [lat, lng] = location.geocord.split(',');
      this.lat = lat;
      this.lng = lng;
      this.coordinates = new google.maps.LatLng(this.lat, this.lng);
    }
    this.mapOptions = {
      zoom: 14,
      mapTypeControl: false,
      ...(this.coordinates && { center: this.coordinates })
    };

    this.locationListSubscription =
      this.commonService.locationListRes.subscribe((res) => {
        this.locationList = res;
      });

    this.intervalTime = 100 / 6;

    this.filterChangeSubscription = this.mapControlService.callForFilterChange$
      .pipe(skip(1))
      .subscribe((res) => {
        this.eventVisibility = this.mapControlService.eventVisibility;
      });

    this.mapLoaderSubscription = this.mapControlService.callForMapLoader$
      .pipe(skip(1))
      .subscribe((res) => {
        console.log(res)
        this.showMapLoader = true;
        this.clearEventLoops();
        this.showMapLoader = this.setVehicleAtTime(res.time);     
      });
      this.mapControlService.startCall$.subscribe((startTripBool) => {
        if (this.mapControlService.isTripEnded) {
          this.clearEventLoops();
          this.mapControlService.isTripEnded = false;
          if (this.noInternetAnimation) {
            clearInterval(this.noInternetAnimation);
            this.busImageURL = this.envService.getReplayImgSrc()+'assets/icons/bus-on-map.svg';
            this.noInternetAnimation = null;
          }    
        }
        console.log('startTripBool called', startTripBool);     
        if (startTripBool) {
          this.startTrip();
        }
      });
  }
  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }
  ngAfterViewInit() {
    this.createSpeedometerChart();

    this.vehicleStoppageIndexes =
      this.eventLogicService.getEvent('vehicle-stoppage');
    this.sosArrayRes = this.eventLogicService.getEvent('sos');
    this.overspeedingIntervals =
      this.eventLogicService.getEvent('overspeeding');
    this.networkLossIntervals = this.eventLogicService.getEvent('network-loss');
    this.deviceOffIntervals = this.eventLogicService.getEvent('device-off');
    this.gpsLossIntervals = this.eventLogicService.getEvent('gps-loss');
    this.noShowInterval = this.driverData["noShowDriverActions"];  
    this.vehicleArrival = this.driverData["vehicleArrivedDriverActions"];
    this.callEmployee = this.driverData["callEmployeeDriverActions"]
    this.calcPickupDropEmpsForStops();

    this.mapInitializer();

    this.showPlannedRoute();
    this.commonService.employeeDetails$.subscribe((res)=>{
      this.employeeDetails=res;
    })
    this.commonService.newShuttleStops.subscribe((res) => {
      this.newShuttleStops = res;
     });
    this.restartCallSubscription =
      this.mapControlService.restartCall$.subscribe((res) => {
        console.log('restart called');
        this.mapControlService.shuttleStopMarkerList = [];
        this.plotMarkers();
      });
      
    // Plotting vehicle at start
    const busImage = {
      url: this.envService.getReplayImgSrc()+'assets/icons/bus-on-map.svg',
      scaledSize: new google.maps.Size(40, 40),
      anchor: new google.maps.Point(13, 13),
    };
    try {
      const lat = this.locationList?.[0]?.latitude;
      const lng = this.locationList?.[0]?.longitude;
      if (lat == null || lng == null) return;
      this.mapControlService.mapVehicleMarker = new google.maps.Marker({
        position: new google.maps.LatLng(lat,lng),
        map: this.map,
        icon: busImage,
      });
      const infoWindow = new google.maps.InfoWindow({
        content: `
        <div class="ota-otd-infobox">
        <span>Bus Number: <b>${this.tripDetails.vehicle.vehicleIdentification}</b></span>
        <span>Driver: <b>${this.tripDetails.driver?.name}</b></span>
      </div>`,
      });
      this.mapControlService.mapVehicleMarker.addListener('click', () => {
        infoWindow.open(this.map, this.mapControlService.mapVehicleMarker);
      });
  
    } catch (error) {
      console.log(error);
    }
    let elemSel = document.querySelector(
      'img[src*="bus-on-map.svg"]'
    ) as HTMLElement;

    // testing
    this.showMapLoader=true;
    console.log(this.mapControlService.shuttleStopMarkerList)
    setTimeout(() => {
      this.map?.setZoom(this.map.getZoom() - 2);
      this.map?.setCenter(
        this.mapControlService.shuttleStopMarkerList[
          Math.max( Math.floor(this.mapControlService.shuttleStopMarkerList.length / 2) -
          1,0)
        ].getPosition()  
      );
      this.commonService.fixedToEnd.next(true);
    this.showMapLoader=false;
    }, 500);
  }
  plotNoShow(noShow,location,indexMile) {
    const noShowGeoCodesMap = noShow.map((obj: any) => {
      const [lat, lng] = obj.geoCode.split(",");
      const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      return {time:obj.markedAt , position, empName: obj.empName, employeeId: obj.empId, markedAt: DateUtils.formatTime(obj.markedAt, 'hh:mm'), plannedAt: obj.plannedLocation.address, markedBy: obj.markedBy ,proximity:obj.proximity};
    });

    const icon = {
      url: `${this.imgSrc}assets/icons/no-show-on-map.svg`,
      scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
      labelOrigin: new google.maps.Point(40, 40), // Position of the label (number) relative to the marker icon
    };
    for (let i = 0; i < noShowGeoCodesMap.length; i++) {

      if(indexMile>0 && noShowGeoCodesMap[i].time>=this.locationList[indexMile-1].time && noShowGeoCodesMap[i].time<=this.locationList[indexMile].time ){

      const marker = new google.maps.Marker({
        position: noShowGeoCodesMap[i].position,
        map: this.map,
        icon: icon,
      });
      let openTooltip: any = null;
      // Create a custom tooltip for each marker
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      tooltip.innerHTML = `
      <div class="no-show-tooltip">
      <div>
          <h2 class="red">No Show</h2>
  
          <p class="h7"><span>Marked at</span>:${noShowGeoCodesMap[i]?.markedAt}</p>
          <p class="h7"><span>Planned at</span>:${noShowGeoCodesMap[i]?.plannedAt}</p>
          <p class="h7"><span>Marked For</span>:${noShowGeoCodesMap[i]?.empName}</p>
          <p class="h7"><span>Marked by</span>:${noShowGeoCodesMap[i]?.markedBy}</p>
          <p class="h7"><span>proximity</span>:${noShowGeoCodesMap[i]?.proximity}</p>
          </div>
    </div>
      `;

      marker.addListener('click', () => {
        if (openTooltip && openTooltip.marker === marker) {
          openTooltip.infowindow.close();
          openTooltip = null;
        } else {
          const infowindow = new google.maps.InfoWindow({
            content: tooltip,
          });
          infowindow.open(this.map, marker);
          // Set the current open tooltip to this marker and tooltip
          openTooltip = { marker, infowindow };
        }
      });
      this.map.addListener('click', () => {
        if (openTooltip) {
          openTooltip.infowindow.close(); 
          openTooltip = null;
        }
      });
      this.mapControlService.noshowMarkerList.push(marker);
    }
  }
  }


   convertPickUpToEpoch(pickUp, epochTime) {
    const locationDate = new Date(epochTime);
  
    const [hours, minutes] = pickUp.split(':').map(Number);
  
    const pickUpDate = new Date(locationDate.getFullYear(), locationDate.getMonth(), locationDate.getDate(), hours, minutes);
  
    return pickUpDate.getTime();
  }

  plotSignInLocationMarkers(location,indexMile) {
    const signInLocationGeoCordsMap = this.employeeDetails
      .filter((employee: any) => employee.actualPickupTime !== 0 && employee.actualPickupLocation.geocord !== null) // skip stops where actualPickupTime is null
      .map((employee: any) => {
        const [lat, lng] = employee.actualPickupLocation.geocord.split(",");
        return {
          position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
          name: employee?.name,
          status: employee?.employeeTrackStatus,
          gender:employee.gender,
          empId: employee?.Id,
          pickUp: employee?.signIn,
          signInLocation: employee?.actualPickupLocation?.address,
          plannedLocation: employee?.plannedPickupLocation?.address,
          empStatus: employee.empStatus,
          reportTime:employee.reportTime,
          signInSource:employee.signInSource
        };
      })
      .sort((a: any, b: any) => a.signIn - b.signIn);

    const icon = {
      url: `${this.imgSrc}assets/icons/signInLocation.svg`,
      scaledSize: new google.maps.Size(50, 50),
      labelOrigin: new google.maps.Point(25, 19)
    };

    let openTooltip: any = null; 

    const tooltip = document.createElement("div");
    tooltip.classList.add("tooltip");
    const infowindow = new google.maps.InfoWindow({
      zIndex: 999
    });

    let activeMarker: any;
    for (let i = 0; i < signInLocationGeoCordsMap.length; i++) {
      const pickUpEpoch = this.convertPickUpToEpoch(signInLocationGeoCordsMap[i].pickUp, location.time);
      if(indexMile>0 && pickUpEpoch>=this.locationList[indexMile-1].time && pickUpEpoch<=this.locationList[indexMile].time ){
        const imgSrc = this.envService.getImgSrc()
        const genderIcon = signInLocationGeoCordsMap[i].gender === "Male"
        ? '<span><img src='+imgSrc+'"assets/icons/male_icon.svg" alt="Male Icon"></span>'
        : '<span><img src='+imgSrc+'"assets/icons/female_icon.svg" alt="Female Icon"></span>';
        const marker = new google.maps.Marker({
          position: signInLocationGeoCordsMap[i].position,
          map: this.eventVisibility.get('signin-employee') ? this.map : null,
          icon: icon,
          label: {
            text: (i + 1).toString(),
            color: '#035F6B',
            fontSize: '12px',
            fontWeight: 'bold',
            fontFamily: 'Lato',
            labelOrigin: new google.maps.Point(25, 15) // Adjust to center label
          } as MarkerLabel
        });
  
  
        marker.addListener('click', (res) => {
          if (signInLocationGeoCordsMap[i].empStatus == 'ADHOC') {
            tooltip.innerHTML = `
          <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
            <div class="d-flex flex-dir-col">
              <span class="h7-b">${signInLocationGeoCordsMap[i]?.name}${genderIcon}</span>
              
              <span class="adhoc-color">Adhoc Employee</span>
            </div>
            <div class="d-flex flex-dir-col">
              <span class="h7"><span> Employee ID</span>:&nbsp;${signInLocationGeoCordsMap[i].empId}</span>
              <span class="h7"><span>Pick up</span>:&nbsp;${signInLocationGeoCordsMap[i].pickUp}</span>
              <span class="h7"><span>Signed In</span>:&nbsp;${signInLocationGeoCordsMap[i].signInLocation}</span>
              <span class="h7"><span>Mechanism</span>:&nbsp;${signInLocationGeoCordsMap[i].signInSource}</span>
              <span class="h7"><span>DRT value</span>:&nbsp;${signInLocationGeoCordsMap[i].reportTime}</span>
            </div>
          </div>
        `;
          }
          if (signInLocationGeoCordsMap[i].empStatus == 'DIFFERENT_SIGNIN_LOCATION') {
            tooltip.innerHTML = `
          <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
            <div class="d-flex flex-dir-col">
              <span class="h7-b">${signInLocationGeoCordsMap[i]?.name}${genderIcon}</span>
              <span class="different-sign-in-color">Different Sign-In Location</span>
            </div>
            <div class="d-flex flex-dir-col">
              <span class="h7"><span> Employee ID</span>:&nbsp;${signInLocationGeoCordsMap[i].empId}</span>
              <span class="h7"><span>Pick up</span>:&nbsp;${signInLocationGeoCordsMap[i].pickUp}</span>
              <span class="h7"><span>Signed In</span>:&nbsp;${signInLocationGeoCordsMap[i].signInLocation}</span>
              <span class="h7"><span>Planned</span>:&nbsp;${signInLocationGeoCordsMap[i].plannedLocation}</span>
              <span class="h7"><span>Mechanism</span>:&nbsp;${signInLocationGeoCordsMap[i].signInSource}</span>
              <span class="h7"><span>DRT value</span>:&nbsp;${signInLocationGeoCordsMap[i].reportTime}</span>
            </div>
          </div>
        `;
          }
          if (signInLocationGeoCordsMap[i].empStatus == 'PLANNED') {
            tooltip.innerHTML = `
          <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
            <div class="d-flex flex-dir-col">
              <span class="h7-b">${signInLocationGeoCordsMap[i]?.name}${genderIcon}</span>
              <span class="planned-color">Planned</span>
            </div>
            <div class="d-flex flex-dir-col">
            <span class="h7"><span> Employee ID</span>:&nbsp;${signInLocationGeoCordsMap[i].empId}</span>
              <span class="h7"><span>Pick up</span>:&nbsp;${signInLocationGeoCordsMap[i].pickUp}</span>
              <span class="h7"><span>Signed In</span>:&nbsp;${signInLocationGeoCordsMap[i].signInLocation}</span>
              <span class="h7"><span>Planned</span>:&nbsp;${signInLocationGeoCordsMap[i].plannedLocation}</span>
              <span class="h7"><span>Mechanism</span>:&nbsp;${signInLocationGeoCordsMap[i].signInSource}</span>
              <span class="h7"><span>DRT value</span>:&nbsp;${signInLocationGeoCordsMap[i].reportTime}</span>
            </div>
          </div>
        `;
          }
          console.log('marker res', res.domEvent);
  
          if (activeMarker === marker) {
            infowindow.close();
            activeMarker = null;
            return;
  
          }
  
          // if (openTooltip && openTooltip.marker === marker) {
          //   infowindow.close();
          //   openTooltip = null;
          // }
          // else {
          // Create a new tooltip and open it
          activeMarker = marker;
          infowindow.setContent(tooltip);
          infowindow.open(this.map, marker);
  
          // }
        });
        this.mapControlService.SignInLocationsMarkerList.push(marker);  

        console.log(new Set(this.mapControlService.SignInLocationsMarkerList))
      }

    }
  }
  plotCallEmployeeMarkersOnMap(location) {
    // Extract all the geoCode values
    const callEmployeesGeoCodesMap =Array.isArray(this.callEmployee) ?
     this.callEmployee?.
    filter((obj: any) => obj && obj.geoCode)
    ?.map((obj: any) => {
      const [lat, lng] = obj.geoCode.split(",");
      const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      return { position, empName: obj.empName, empId: obj.empId, pickUp: DateUtils.formatTime(obj.pickUpTime, 'hh:mm'),callNumber: obj.phoneNumber,callStart: DateUtils.formatTime(obj.callStartTime, 'hh:mm'), callDuration: obj.callDuration, callStatus: obj.callStatus, callTime:obj.callStartTime };
    }) : [];

    const icon = {
      url: `${this.imgSrc}assets/icons/call-employee-marker-on-map.svg`,
    };

    for (let i = 0; i < callEmployeesGeoCodesMap.length; i++) {

      if(Math.abs(callEmployeesGeoCodesMap[i].callTime-location.time)<20000){
        const marker = new google.maps.Marker({
          position: callEmployeesGeoCodesMap[i].position,
          map: this.map,
          icon: icon,
        });
        // Create a custom tooltip for each marker
        let openTooltip: any = null;
        const tooltip = document.createElement("div");
        tooltip.classList.add("tooltip");
        tooltip.innerHTML = `
          <div class="call-employee-tool-tip" >
          <div>
              <h2>Call Employee</h2>
              <p><span>Employee name</span>:${callEmployeesGeoCodesMap[i].empName}</p>

              <p><span>Call Start</span>:${callEmployeesGeoCodesMap[i].callStart}</p>

              <p><span>Call Duration</span>:${callEmployeesGeoCodesMap[i].callDuration} seconds</p>
              <p><span>Call Status</span>: ${callEmployeesGeoCodesMap[i].callStatus}</p>
          </div>
       </div>
          `;
        marker.addListener('click', () => {
          if (openTooltip && openTooltip.marker === marker) {
            openTooltip.infowindow.close();
            openTooltip = null;
          }
          else {
            const infowindow = new google.maps.InfoWindow({
              content: tooltip,
            });
            infowindow.open(this.map, marker);
            openTooltip = { marker, infowindow };
          }
        });
        this.map.addListener('click', () => {
          if (openTooltip) {
            openTooltip.infowindow.close(); 
            openTooltip = null;
          }
        });
  
        this.mapControlService.CallEmpMarkerList.push(marker);
      }

    }
  }
  clearEventLoops() {
    this.indexForMilestone = 0;
    this.formattedWaypoints = [];
    this.overspeedformattedWaypoints = [];
    this.gpsLossWaypoints = [];
    this.showOverlay = false;
    this.isOverspeeding = false;
    this.startPlottingOverspeed = false;
    this.startNetworkLoss = false;
    this.deviceOffStart = false;
    this.gpsLossStart = false;
    if (this.noInternetAnimation) {
      clearInterval(this.noInternetAnimation);
      this.busImageURL = this.envService.getReplayImgSrc()+'assets/icons/bus-on-map.svg';
    }
  }

  setVehicleAtTime(time: number): boolean {
    if (this.mapControlService.mapVehicleMarker == null) {
      const firstLocation = this.locationList?.[0];
      if (firstLocation && isValidCoordinate(firstLocation.latitude, firstLocation.longitude)) {
        this.vehicleCurrentLocationCords = new google.maps.LatLng(
          firstLocation.latitude,
          firstLocation.longitude
        );
        const bearing = firstLocation?.mBearing;
      this.vehiclePreviousCoords = {
        lat: this.vehicleCurrentLocationCords?.lat(),
        lng: this.vehicleCurrentLocationCords?.lng(),
      };
      const busImage = {
        url: this.envService.getReplayImgSrc()+'assets/icons/bus-on-map.svg',
        scaledSize: new google.maps.Size(40, 40),
        anchor: new google.maps.Point(13, 13),
      };

      this.mapControlService.mapVehicleMarker = new google.maps.Marker({
        position: this.vehicleCurrentLocationCords,
        map: this.map,
        icon: busImage,
      });

      const infoWindow = new google.maps.InfoWindow({
        content: `
        <div class="ota-otd-infobox">
        <span>Bus Number: <b>${this.tripDetails.vehicle.vehicleIdentification}</b></span>
        <span>Driver: <b>${this.tripDetails.driver?.name}</b></span>
      </div>`,
      });

      const marker = this.mapControlService.mapVehicleMarker;
      if(marker){
      marker.addListener('click', () => {
        // Open the InfoWindow
        infoWindow.open(this.map, marker);
      });
    }

      let elemSel = document.querySelector(
        'img[src*="bus-on-map.svg"]'
      ) as HTMLElement;

      if (elemSel && bearing != null) {
        elemSel.style.transform = `rotate(${bearing}deg)`;
      }
    }
    }

    // check if the vehicle moves out of map view
    if (this.mapControlService.mapVehicleMarker) {
    google.maps.event.addListener(
      this.mapControlService.mapVehicleMarker,
      'position_changed',
      () => {
        const markerPosition =
          this.mapControlService.mapVehicleMarker?.getPosition();
        const mapBounds = this.map?.getBounds();

        if (mapBounds && markerPosition && !mapBounds.contains(markerPosition)) {
          this.map?.setCenter(markerPosition);     
        }
      }
    );
  }
    const currMilestone = this.locationList && this.locationList[this.indexForMilestone] ? this.locationList[this.indexForMilestone] : null;

    for (
      ;
      this.mapControlService.timer <= time;
      this.mapControlService.timer += 1000
    ) {
      if (
        this.indexForMilestone < this.locationList.length && currMilestone?.time &&
        Math.abs(
         currMilestone.time -
          this.mapControlService.timer
        ) < 1000
      ) {
        this.quickSetMap(this.locationList[this.indexForMilestone],this.indexForMilestone);
        this.indexForMilestone++;
        if (this.indexForMilestone === this.locationList.length) {
          this.indexForMilestone--;
        }
      }
      if (this.mapControlService.timer>time && this.mapControlService.timer > currMilestone?.time) {
        this.mapControlService.timer = Math.max(this.locationList[this.indexForMilestone]?.time,this.locationList[this.indexForMilestone]?.time -1000);
      }
     

    }
    // Set vehicle location
  if (currMilestone && this.mapControlService.mapVehicleMarker) {
    const bearing = currMilestone?.mBearing;
    var imgIcon = this.mapControlService.mapVehicleMarker?.getIcon?.();
    if(imgIcon) {
      imgIcon['rotation'] = bearing;
    }
    if (isValidCoordinate(currMilestone?.latitude, currMilestone?.longitude)) {
    this.vehiclePreviousCoords = {
      lat: currMilestone.latitude,
      lng: currMilestone.longitude,
    };
    this.mapControlService.mapVehicleMarker.setIcon(imgIcon);
    this.mapControlService.mapVehicleMarker.setPosition({
      lat: currMilestone.latitude,
      lng: currMilestone.longitude,
    });
    }
    let elemSel = document.querySelector(
      'img[src*="bus-on-map.svg"]'
    ) as HTMLElement;
    if (elemSel && bearing != null && bearing != 0) {
      elemSel.style.transform = `rotate(${bearing}deg)`;
    }

    // set speed
    const mSpeed = currMilestone?.mSpeed;
    this.vehicleSpeed = (mSpeed && isFinite(mSpeed))
      ? Math.floor(mSpeed * 3.6)
      : 0;
    if (this.vehicleSpeed > this.mapControlService.thresholdSpeed) {
      this.isOverspeeding = true;
    } else {
      this.isOverspeeding = false;
    }
}
    const chart = Highcharts.charts[Highcharts.charts.length - 1];
    if (chart && !chart.renderer['forExport'] && chart.series?.length > 0) {
      const point = chart.series[0]?.points?.[0],
        inc = this.vehicleSpeed;

      let newVal = inc;
      // if (newVal < 0 || newVal > 200) {
      //   newVal = point.y - inc;
      // }
      if(this.options?.series) {
      this.options.series[0].dataLabels = {
        color:
          this.vehicleSpeed > this.mapControlService.thresholdSpeed
            ? '#FF0404'
            : '#333333',
      };
      chart.update(this.options);
    }

      point.update(newVal);
    }
    // this.showMapLoader = false;
    // return to change hide loader
    return false;
  }

  quickSetMap(location: any,indexMile) {
    // Get location position
    const vehiclePosition = new google.maps.LatLng(
      location.latitude,
      location.longitude
    );

    // Stop GPS loss interval
    if (this.gpsLossStart) {
      this.gpsLossWaypoints.push(vehiclePosition);
      this.plottingPolyLine(
        this.eventVisibility.get('no-gps') ? this.map : null,
        this.startPlottingOverspeed,
        this.gpsLossStart
      );
      this.gpsLossWaypoints = [];
      this.gpsLossStart = false;
    }

    // GPS Loss
    this.gpsLossIntervals?.forEach((interval) => {
      if (interval[0].time == location.time) {
        this.gpsLossStart = true;
        this.gpsLossWaypoints.push(vehiclePosition);
        this.currentGPSLossData = interval
      }
    });

    // for next iteration set deviceOff end
    if (this.deviceOffStart && indexMile>0 && this.currentDeviceOff && this.currentDeviceOff[1] <= location.time && this.currentDeviceOff[1]>this.locationList[indexMile-1].time) {
      this.deviceOffStart = false;
      this.showOverlay=false;
      // set marker
      let deviceNotConnectedMarker = new google.maps.Marker({
        position: new google.maps.LatLng(location.latitude, location.longitude),
        map: this.eventVisibility.get('device-off') ? this.map : null,
        icon: 'assets/icons/device-off.svg',
        zIndex: 100,
      });

      const tooltipContent = `
      <div class="custom-tooltip">
        <h3>Device Off</h3>
        <p>Duration: ${DateUtils.formatTime(this.currentDeviceOff[0], "hh:mm")} - ${DateUtils.formatTime(this.currentDeviceOff[1], "hh:mm")}</p>
        <p>Length: ${this.currentDeviceOff[3]} minutes</p>
      </div>
    `;
    const deviceOffInfoWindow = new google.maps.InfoWindow({
      content: tooltipContent,
    });
  
    deviceNotConnectedMarker.addListener('click', () => {
      deviceOffInfoWindow.open(this.map, deviceNotConnectedMarker);
    });
  
    this.map.addListener('click', () => {
      deviceOffInfoWindow.close();
    });


      this.mapControlService.deviceNotConnectedMarkerList.push(
        deviceNotConnectedMarker
      );
      this.currentDeviceOff  = null;
    }

    // Device/Application off
  if(this.deviceOffIntervals && Array.isArray(this.deviceOffIntervals)){
    this.deviceOffIntervals.forEach((interval) => {
      if (indexMile>0 && interval[2] <= location.time && interval[2]>this.locationList[indexMile-1].time) {
        this.currentDeviceOff = interval
        this.deviceOffStart = true;
        let deviceNotConnectedMarker = new google.maps.Marker({
          position: new google.maps.LatLng(
            location.latitude,
            location.longitude
          ),
          map: this.eventVisibility.get('device-off') ? this.map : null,
          icon: 'assets/icons/device-off.svg',
          zIndex: 100,
        });
        
        const tooltipContent = `
          <div class="custom-tooltip">
            <h3>Device Off</h3>
            <p>Duration: ${DateUtils.formatTime(interval[0], "hh:mm")} - ${DateUtils.formatTime(interval[1], "hh:mm")}</p>
            <p>Length: ${interval[3]} minutes</p>

          </div>
        `;
        const deviceOffInfoWindow = new google.maps.InfoWindow({
          content: tooltipContent,
        });
      
        deviceNotConnectedMarker.addListener('click', () => {
          deviceOffInfoWindow.open(this.map, deviceNotConnectedMarker);
        });
      
        this.map.addListener('click', () => {
          deviceOffInfoWindow.close();
        });
    

        this.mapControlService.deviceNotConnectedMarkerList.push(
          deviceNotConnectedMarker
        );
    
        setTimeout(() => {
          deviceNotConnectedMarker.setAnimation(null);
        }, 100);
    
        this.assetPath = {
          '--path': 'url(../../../../assets/icons/device-off-symbol.svg)',
        };
        this.showOverlay = true;
      }
    });
  }

    if ( 
      Array.isArray(this.networkLossIntervals) &&
      this.networkLossIntervals.some(
        (interval) => interval[1] == location.time
      ) &&
      this.startNetworkLoss
    ) {
      this.startNetworkLoss = false;
      // set end Marker
      const noNetworkMarker = new google.maps.Marker({
        position: new google.maps.LatLng(location.latitude, location.longitude),
        map: this.eventVisibility.get('no-network-start') ? this.map : null,
        icon: 'assets/icons/no-network-end.svg',
        zIndex: 100,
      });

      this.addMarkerTooltip(
        noNetworkMarker,
        'Network Loss Ended',
        this.map,
        location.time
      );

      setTimeout(() => {
        noNetworkMarker.setAnimation(null);
      }, 100);

      this.mapControlService.noNetworkMarkerList.push(noNetworkMarker);
    }

    // Network Loss
    if (
      Array.isArray(this.networkLossIntervals) && this.networkLossIntervals.some(interval => interval[0] == location.time)
    ) {
      this.startNetworkLoss = true;
      const interval = this.networkLossIntervals.find(
        (interval) => interval[0] == location.time
      );

      // set start Marker
      const noNetworkMarker = new google.maps.Marker({
        position: new google.maps.LatLng(location.latitude, location.longitude),
        map: this.eventVisibility.get('no-network-start') ? this.map : null,
        icon: 'assets/icons/no-network-start.svg',
        zIndex: 100,
      });
      this.mapControlService.noNetworkMarkerList.push(noNetworkMarker);
      this.addMarkerTooltip(
        noNetworkMarker,
        'Network Loss Started',
        this.map,
        location.time
      );
    }

    this.plotNoShow(this.noShowInterval,location,indexMile)
    this.plotSignInLocationMarkers(location,indexMile);
    this.plotCallEmployeeMarkersOnMap(location);

    // Set vehicle stoppage
    if(this.vehicleStoppageIndexes?.length){
      this.vehicleStoppageIndexes.forEach((loc) => {
        if(indexMile>0 && loc.startTime>=this.locationList[indexMile-1].time && loc.startTime<this.locationList[indexMile].time){
          let vehicleStopageMarker = new google.maps.Marker({
            position: new google.maps.LatLng(location.latitude, location.longitude),
            map: this.eventVisibility.get('vehicle-stoppage') ? this.map : null,
            icon: 'assets/icons/vehicle-stoppage.svg',
            zIndex: 100,
          });
      
          const vehicleStoppageTooltipContent = `
            <div class="vehicle-stoppage-tooltip">
              <div>
              <h2>Vehicle Stoppage</h2>
              <p><span>Alert Status</span>: ${loc.status}</p>
              <p><span>Alert Type</span>: ${loc.alertSeverity}</p>
              <p><span>Duration </span>: ${DateUtils.formatTime(loc.startTime, "hh:mm")} : ${DateUtils.formatTime(loc.endTime, "hh:mm")}</p>
              <p><span>Set threshold value</span>: ${loc.thresholdvalue}m</p>
              </div>   
            </div>
          `;
      
          const vehicleStoppageInfoWindow = new google.maps.InfoWindow({
            content: vehicleStoppageTooltipContent,
          });
      
          vehicleStopageMarker.addListener('click', () => {
            vehicleStoppageInfoWindow.open(this.map, vehicleStopageMarker);
          });
      
          this.map.addListener('click', () => {
            vehicleStoppageInfoWindow.close();
          });
      
          this.mapControlService.vehicleStoppageMarkerList.push(vehicleStopageMarker);
        }
      })
    }

    // Set SOS
    if (this.sosArrayRes.length) {
      this.sosArrayRes.forEach((loc) => {
        let currentInfoWindow: google.maps.InfoWindow | null = null;
          if(indexMile>0 && loc.time>=this.locationList[indexMile-1].time && loc.time<this.locationList[indexMile].time){
            const sosMarker = new google.maps.Marker({
            position: vehiclePosition,
            map: this.eventVisibility.get('sos') ? this.map : null,
            icon: 'assets/icons/sos.svg',
            zIndex: 102,
          });
    
          const tooltipContent = `
            <div class="sos-marker-tooltip">
              <div>
               <h2>SOS Raised</h2>
              <p><span>Alert Status</span>: ${loc.status}</p>
              <p><span>Alert Type</span>: ${loc.alertSeverity}</p>
              <p><span>Duration </span>: ${DateUtils.formatTime(loc.startTime, "hh:mm")} : ${DateUtils.formatTime(loc.endTime, "hh:mm")}</p>
              <p><span>Raised From</span>: ${loc.raisedFrom}</p>
              </div>    
            </div>
          `;

          const infoWindow = new google.maps.InfoWindow({
            content: tooltipContent,
          });
      sosMarker.addListener('click', () => {
        if (currentInfoWindow) {
          currentInfoWindow.close(); // Close the currently open InfoWindow
        }

        if (currentInfoWindow !== infoWindow) {
          infoWindow.open(this.map, sosMarker);
          currentInfoWindow = infoWindow; // Update the reference to the currently open InfoWindow
        } else {
          currentInfoWindow = null; // Clicked on the same marker, so close the InfoWindow
        }
      });

      this.map.addListener('click', () => {
        if (currentInfoWindow) {
          currentInfoWindow.close(); // Close the InfoWindow if clicking on the map
          currentInfoWindow = null;
        }
      });
    
          setTimeout(() => {
            sosMarker.setAnimation(null);
          }, 100);
    
          this.giveVehiclePause();
          this.mapControlService.sosMarkerList.push(sosMarker);
        }
      });
    }
    
    if (
      this.geofenceHittedStops.get(
        location.latitude.toFixed(5) + ',' + location.longitude.toFixed(5)
      ) != undefined
    ) {
      const index = this.geofenceHittedStops.get(
        location.latitude.toFixed(5) + ',' + location.longitude.toFixed(5)
      );
      const currShuttleStop = this.tripDetails.shuttleStops[index];
      const shuttleStopPostion = new google.maps.LatLng(
        Number(currShuttleStop.geoCord.split(',')[0]),
        Number(currShuttleStop.geoCord.split(',')[1])
      );
      let type: string = 'on time';
      let infoWindowContent: string = ' on time';
      if (currShuttleStop.arrivalTimeDiff > 0) {
        type = 'late';
        infoWindowContent = ' late';
      }
      const currShuttleStopMarker =
        this.mapControlService.shuttleStopMarkerList[index];
      if (
        (this.tripDetails.direction === 'OUT' && index !== 0) ||
        (this.tripDetails.direction === 'IN' &&
          index !== this.tripDetails.shuttleStops.length - 1)
      ) {
        const newMarkerIcon = {
          url: 'assets/icons/map-emp-pickup.svg', // URL to your custom marker icon image
          scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
          labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
        };
        currShuttleStopMarker.setOptions({
          icon: newMarkerIcon,
          label: {
            text: index + 1 < 10 ? '0' + (index + 1) : '' + (index + 1),
            color: '#FFFFFF',
            fontSize: '14px', // Font size of the label (number)
            fontWeight: 'bold', // Font weight of the label (number)
          },
          zIndex: 101,
        });
      }

      // OTA/OTD for 1st and last stop
      if (index == 0 || index == this.tripDetails.shuttleStops.length - 1) {
        const stop =
          this.tripDetails.direction === 'OUT'
            ? index == 0
              ? 'Office'
              : `Stop ${this.tripDetails.shuttleStops.length}`
            : index == 0
              ? 'Stop 1'
              : 'Office';
        const hours = Math.floor(
          DateUtils.convertMinutesToHours(currShuttleStop.arrivalTimeDiff)
        );
        const minutes = DateUtils.getMinutesFromDuration(currShuttleStop.arrivalTimeDiff);
        const delayedTime =
          currShuttleStop.arrivalTimeDiff > 0
            ? `(${hours ? hours + ' Hrs ' : ''}${minutes} mins)`
            : '';
        if (index == 0) {
          this.mapControlService.shuttleStopMarkerList[0].addListener(
            'click',
            () => {
              this.mapControlService.infoWindowList[0].open(
                this.map,
                this.mapControlService.shuttleStopMarkerList[0]
              );
            }
          );
        } else {
          this.mapControlService.shuttleStopMarkerList[
            this.tripDetails.shuttleStops.length - 1
          ].addListener('click', () => {
            this.mapControlService.infoWindowList[1].open(
              this.map,
              this.mapControlService.shuttleStopMarkerList[
              this.tripDetails.shuttleStops.length - 1
              ]
            );
          });
        }
      }
    }

    // Plot overspeed plotline

    if (
      this.overspeedingIntervals.some(
        (interval) => {
          if(indexMile>0 && interval.startTime <= this.locationList[indexMile].time && interval.startTime > this.locationList[indexMile-1].time){
            this.currentOverSpeedData = interval;
            return true;
          } 
          else 
            return false;
        }
      )
    ) {
      this.startPlottingOverspeed = true;
      
    }

    if (this.startPlottingOverspeed) {
      this.overspeedformattedWaypoints.push(
        new google.maps.LatLng(location.latitude, location.longitude)
      );
      if (this.deviceOffStart || this.gpsLossStart) {
        // add buffer
        this.mapControlService.overSpeedPolylineList.push(
          new google.maps.Polyline()
        );
        this.overspeedformattedWaypoints = [];
      }

      this.plottingPolyLine(
        this.map,
        this.startPlottingOverspeed,
        this.gpsLossStart
      );

      if (
        this.overspeedingIntervals.some(
        (interval) => {
          if(indexMile>0 && interval.endTime <= this.locationList[indexMile].time && interval.endTime > this.locationList[indexMile-1].time){
            this.currentOverSpeedData = interval;
            return true;
          } 
          else 
            return false;
        }
      ) 
      ){
        this.startPlottingOverspeed = false;
        this.overspeedformattedWaypoints = [];
        this.mapControlService.overSpeedPolylineList.push(
          new google.maps.Polyline()
        );
        this.currentOverSpeedData=null;
      }
    }

    // set polyline

    this.formattedWaypoints.push(
      new google.maps.LatLng(location.latitude, location.longitude)
    );
    if (this.deviceOffStart || this.gpsLossStart) {
      // add buffer
      this.mapControlService.polylineList.push(new google.maps.Polyline());
      this.formattedWaypoints = [];
    }
    this.plottingPolyLine(
      this.map,
      this.startPlottingOverspeed,
      this.gpsLossStart
    );
  }

  createSpeedometerChart() {
    //HighCharts
    this.options = {
      chart: {
        type: 'gauge',
        plotBackgroundColor: '#F2FBFF',
        plotBackgroundImage: '#F2FBFF',
        plotBorderWidth: 0,
        plotShadow: false,
        height: '80%',
      },

      title: {
        text: 'Speed:',
      },

      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ['50%', '75%'],
        size: '110%',
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 140,
        tickPixelInterval: 10,
        tickPosition: 'inside',
        tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
        tickLength: 20,
        tickWidth: 1,
        minorTickInterval: null,
        labels: {
          distance: 20,
          style: {
            fontSize: '12px',
          },
        },
        lineWidth: 0,
        plotBands: [
          {
            from: 0,
            to: 70,
            color: '#55BF3B', // green
            thickness: 10,
          },
          {
            from: 70,
            to: 80,
            color: '#DDDF0D', // yellow
            thickness: 10,
          },
          {
            from: 80,
            to: 140,
            color: '#DF5353', // red
            thickness: 10,
          },
        ],
      },

      series: [
        {
          name: 'Speed',
          data: [0],
          tooltip: {
            valueSuffix: ' km/h',
          },
          dataLabels: {
            format: '<b>{y}</b> km/h',
            y: 20,
            borderWidth: 0,
            color: '#333333',
            style: {
              textOutline: 'none',
              fontSize: '14px',
              fontWeight: 'normal',
            },
          },
          dial: {
            radius: '80%',
            backgroundColor: 'gray',
            baseWidth: 10,
            baseLength: '0%',
            rearLength: '0%',
          },
          pivot: {
            backgroundColor: 'gray',
            radius: 4,
          },
        },
      ],
    };
    Highcharts.chart('speedometerContainer', this.options);
  }

  startTrip() {
    const marker=this.mapControlService.mapVehicleMarker;
    if (this.firstTripStart && marker) {
      this.firstTripStart = false;
      this.map?.setZoom(this.map.getZoom() + 2);
      const position=marker?.getPosition();
      if(position){
      this.map?.setCenter(position);
      }
    }

    if (this.mapControlService.mapVehicleMarker == null) {
      const firstLocation = this.locationList?.[0];
      if (firstLocation && isValidCoordinate(firstLocation.latitude, firstLocation.longitude)){
      this.vehicleCurrentLocationCords = new google.maps.LatLng(
        firstLocation.latitude,
        firstLocation.longitude
      );
      const bearing = firstLocation?.mBearing;
      this.vehiclePreviousCoords = {
        lat: this.vehicleCurrentLocationCords.lat(),
        lng: this.vehicleCurrentLocationCords.lng(),
      };
      const busImage = {
        url: this.envService.getReplayImgSrc()+'assets/icons/bus-on-map.svg',
        scaledSize: new google.maps.Size(40, 40),
        anchor: new google.maps.Point(13, 13),
      };

      this.mapControlService.mapVehicleMarker = new google.maps.Marker({
        position: this.vehicleCurrentLocationCords,
        map: this.map,
        icon: busImage,
      });

      const infoWindow = new google.maps.InfoWindow({
        content: `
              <div class="ota-otd-infobox">
                <span>Bus Number: <b>${this.tripDetails.vehicle.vehicleIdentification}</b></span>
                <span>Driver: <b>${this.tripDetails.driver?.name}</b></span>
              </div>`,
      });

      // Add click event listener to the marker
      this.mapControlService.mapVehicleMarker.addListener('click', () => {
        // Open the InfoWindow
        infoWindow.open(this.map, this.mapControlService.mapVehicleMarker);
      });

        let elemSel = document.querySelector(
          'img[src*="bus-on-map.svg"]'
        ) as HTMLElement;

      if (elemSel && bearing != null) {
        elemSel.style.transform = `rotate(${bearing}deg)`;
      }
    }
    }

    // check if the vehicle moves out of map view
    if (this.mapControlService.mapVehicleMarker) {
    google.maps.event.addListener(
      this.mapControlService.mapVehicleMarker,
      'position_changed',
      () => {
        const markerPosition =
          this.mapControlService.mapVehicleMarker?.getPosition();
        const mapBounds = this.map?.getBounds();

        if (mapBounds && markerPosition && !mapBounds.contains(markerPosition)) {
          this.map?.setCenter(markerPosition);
        }
      }
    );
  }

    // Main driver function
    // Safe check: only one interval should run
    if (this.mapControlService.tripInterval) {
      clearInterval(this.mapControlService.tripInterval);
    }

    // SetInterval for timer
    this.mapControlService.tripInterval = setInterval(() => {
      // Playback speed is changed
      if (this.mapControlService.isSpeedChanged) {
        this.mapControlService.isSpeedChanged = false;
        clearInterval(this.mapControlService.tripInterval);
        this.intervalTime = 100 / (6 * this.mapControlService.playbackSpeed);
        this.startTrip();
      }

      // If milestone for near timer
      if (
        this.indexForMilestone < this.locationList.length &&
        Math.abs(
          this.locationList[this.indexForMilestone].time -
          this.mapControlService.timer
        ) < 1000
      ) {
        this.setVehicleMarker(this.locationList[this.indexForMilestone],this.indexForMilestone);
        // Set speedometer speed
        this.vehicleSpeed = Math.floor(
          this.locationList[this.indexForMilestone]['mSpeed'] * 3.6
        );
        if (this.vehicleSpeed > this.mapControlService.thresholdSpeed) {
          this.isOverspeeding = true;
        } else {
          this.isOverspeeding = false;
        }
        const chart = Highcharts.charts[Highcharts.charts.length - 1];
        if (chart && !chart.renderer['forExport']) {
          const point = chart.series[0].points[0],
            inc = this.vehicleSpeed;

          let newVal = inc;
          // if (newVal < 0 || newVal > 200) {
          //   newVal = point.y - inc;
          // }
          this.options.series[0].dataLabels = {
            color:
              this.vehicleSpeed > this.mapControlService.thresholdSpeed
                ? '#FF0404'
                : '#333333',
          };
          chart.update(this.options);
          point.update(newVal);
        }

        this.indexForMilestone += 1;
      }

      // Driver
      this.mapControlService.tripPlayer$.next(this.mapControlService.timer);
      if(this.indexForMilestone < this.locationList.length ){
        if(this.mapControlService.timer < this.locationList[this.indexForMilestone].time)
          {
            this.mapControlService.timer += 1000; // 1000 * 60 ms = 60s in 1s
          }
          else{
            this.mapControlService.timer = this.locationList[this.indexForMilestone].time; // 1000 * 60 ms = 60s in 1s
          }
      }
      else{
        this.mapControlService.tripEndCall$.next(true);
        this.mapControlService.tripPlayer$.next(this.tripDetails.actualEndTime);
        clearInterval(this.mapControlService.tripInterval);
        this.mapControlService.endTrip();
      }

      // End trip
      if (this.mapControlService.timer >= this.tripDetails.actualEndTime) {
        // If no geofence hit at office in login
        if (
          this.tripDetails.direction === 'IN' &&
          this.tripDetails.shuttleStops[
            this.tripDetails.shuttleStops.length - 1
          ].actualArrivalGeoCode == null
        ) {
          const currshuttleMarker =
            this.mapControlService.shuttleStopMarkerList[
            this.tripDetails.shuttleStops.length - 1
            ];
          const arrivalTimeDiff =
            this.tripDetails.actualEndTime - this.tripDetails.plannedEndTime;
          const hours = Math.floor(
            DateUtils.convertMillisecondsToHours(arrivalTimeDiff)
          );
      
            const minutes = DateUtils.getMinutesFromMilliseconds(arrivalTimeDiff);

          const delayedTime =
            arrivalTimeDiff > 60 * 1000 // 60 seconds
              ? `(${hours ? hours + ' Hrs ' : ''}${minutes} mins)`
              : '';
          let type = arrivalTimeDiff > 60 * 1000 ? 'late' : 'on time';
        }

        clearInterval(this.mapControlService.tripInterval);
        this.mapControlService.tripPlayer$.next(this.tripDetails.actualEndTime);
        this.indexForMilestone = 0;
        this.isOverspeeding = false;
        this.resetSpeedoMeter()
        this.mapControlService.endTrip();
      }
    }, this.intervalTime);
  }


  resetSpeedoMeter () {
    const chart = Highcharts.charts[Highcharts.charts.length - 1];
    if (chart && !chart.renderer['forExport']) {
      const point = chart.series[0].points[0];
      let newVal = 0;
      this.options.series[0].dataLabels = {
        color:
          this.vehicleSpeed > this.mapControlService.thresholdSpeed
            ? '#FF0404'
            : '#333333',
      };
      chart.update(this.options);
      point.update(newVal);
    }
  }
  geofenceHittingCircle(position: any, type: string) {
    this.circleRadius = 0;
    this.circleOpacity = 0.24;
    this.geofenceMarker = new google.maps.Circle({
      fillColor: type === 'on time' ? '#25FF01' : '#FF0101',
      fillOpacity: this.circleOpacity,
      strokeColor: '#fff',
      strokeOpacity: 0,
      map: this.map,
      center: position,
      radius: this.circleRadius,
    });

    this.mapControlService.geofenceCirclesList.push(this.geofenceMarker);

    const animationInterval = setInterval(() => {
      this.circleRadius += 5;
      this.geofenceMarker.setRadius(this.circleRadius);
      if (this.circleRadius > 500) {
        clearInterval(animationInterval);
        const fadeInterval = setInterval(() => {
          if (this.geofenceMarker.get('fillOpacity') > 0) {
            this.circleOpacity = this.geofenceMarker.get('fillOpacity') - 0.01;
            this.geofenceMarker.set(
              'fillOpacity',
              Math.max(0, this.circleOpacity)
            );
          } else {
            clearInterval(fadeInterval);
          }
        }, 10);
      }
    }, 5);
  }

  setVehicleMarker(location: any,indexMile) {
   // Get location position
    const vehiclePosition = new google.maps.LatLng(
      location.latitude,
      location.longitude
    );

    // Stop GPS loss interval
    if (this.gpsLossStart) {
      this.gpsLossWaypoints.push(vehiclePosition);
      this.plottingPolyLine(
        this.eventVisibility.get('no-gps') ? this.map : null,
        this.startPlottingOverspeed,
        this.gpsLossStart
      );
      this.gpsLossWaypoints = [];
      this.gpsLossStart = false;
      this.showOverlay = false;
    }

    // GPS Loss
    this.gpsLossIntervals.forEach((interval) => {
      if (interval[0].time == location.time) {
        this.gpsLossStart = true;
        this.assetPath = {
          '--path': 'url(../../../../assets/icons/gps-loss-symbol.svg)',
        };
        this.showOverlay = true;

        this.gpsLossWaypoints.push(vehiclePosition);
      }
    });

    // for next iteration set deviceOff end
    if (this.deviceOffStart && indexMile>0 &&  this.currentDeviceOff && this.currentDeviceOff[1] <= location.time && this.currentDeviceOff[1]>this.locationList[indexMile-1].time) {
      this.deviceOffStart = false;
      this.showOverlay = false;
      // set marker
      let deviceNotConnectedMarker = new google.maps.Marker({
        position: new google.maps.LatLng(location.latitude, location.longitude),
        animation: google.maps.Animation.BOUNCE,
        map: this.eventVisibility.get('device-off') ? this.map : null,
        icon: 'assets/icons/device-off.svg',
        zIndex: 100,
      });

      const tooltipContent = `
      <div class="custom-tooltip">
        <h3>Device Off</h3>
        <p>Duration: ${DateUtils.formatTime(this.currentDeviceOff[0], "hh:mm")} - ${DateUtils.formatTime(this.currentDeviceOff[1], "hh:mm")}</p>
        <p>Length: ${this.currentDeviceOff[3]} minutes</p>
      </div>
    `;
    const deviceOffInfoWindow = new google.maps.InfoWindow({
      content: tooltipContent,
    });
  
    deviceNotConnectedMarker.addListener('click', () => {
      deviceOffInfoWindow.open(this.map, deviceNotConnectedMarker);
    });
  
    this.map.addListener('click', () => {
      deviceOffInfoWindow.close();
    });

      this.mapControlService.deviceNotConnectedMarkerList.push(
        deviceNotConnectedMarker
      );

      setTimeout(() => {
        deviceNotConnectedMarker.setAnimation(null);
      }, 100);
    }

    // Device/Application off
    this.deviceOffIntervals.forEach((interval) => {
      if (indexMile>0 && interval[2] <= location.time && interval[2]>this.locationList[indexMile-1].time) {
        this.deviceOffStart = true;
        let deviceNotConnectedMarker = new google.maps.Marker({
          position: new google.maps.LatLng(
            location.latitude,
            location.longitude
          ),
          animation: google.maps.Animation.BOUNCE,
          map: this.eventVisibility.get('device-off') ? this.map : null,
          icon: 'assets/icons/device-off.svg',
          zIndex: 100,
        });
    
        const tooltipContent = `
        <div class="custom-tooltip">
          <h3>Device Off</h3>
          <p>Duration: ${DateUtils.formatTime(interval[0], "hh:mm")} - ${DateUtils.formatTime(interval[1], "hh:mm")}</p>
          <p>Length: ${interval[3]} minutes</p>
        </div>
      `;
      const deviceOffInfoWindow = new google.maps.InfoWindow({
        content: tooltipContent,
      });
    
      deviceNotConnectedMarker.addListener('click', () => {
        deviceOffInfoWindow.open(this.map, deviceNotConnectedMarker);
      });
    
      this.map.addListener('click', () => {
        deviceOffInfoWindow.close();
      });
    
        this.assetPath = {
          '--path': 'url(../../../../assets/icons/device-off-symbol.svg)',
        };
        this.showOverlay = true;
      }
    });

    // Network Loss
    if (
      Array.isArray(this.networkLossIntervals) &&this.networkLossIntervals.some(interval => interval[0] == location.time) 
       ) {
      this.startNetworkLoss = true;
      const interval = this.networkLossIntervals.find(
        (interval) => interval[0] == location.time
      );

      // set start Marker
      const noNetworkMarker = new google.maps.Marker({
        position: new google.maps.LatLng(location.latitude, location.longitude),
        animation: google.maps.Animation.BOUNCE,
        map: this.eventVisibility.get('no-network-start') ? this.map : null,
        icon: 'assets/icons/no-network-start.svg',
        zIndex: 100,
      });

      this.addMarkerTooltip(
        noNetworkMarker,
        'Network Loss Started',
        this.map,
        location.time
      );

      setTimeout(() => {
        noNetworkMarker.setAnimation(null);
      }, 100);

      this.mapControlService.noNetworkMarkerList.push(noNetworkMarker);

      const noInternetBusUrl = 'assets/icons/no-network-bus-on-map.svg';
      const busImage = this.envService.getReplayImgSrc()+'assets/icons/bus-on-map.svg';

      this.noInternetAnimation = setInterval(() => {
        if (
          this.mapControlService.mapVehicleMarker?.getIcon()['url'] === busImage
        ) {
          this.busImageURL = noInternetBusUrl;
        } else {
          this.busImageURL = busImage;
        }
      }, 500);
    }
    if (
      this.networkLossIntervals.some((interval) => interval[1] == location.time)
    ) {
      if (this.noInternetAnimation) {
        clearInterval(this.noInternetAnimation);
        this.busImageURL = this.envService.getReplayImgSrc()+'assets/icons/bus-on-map.svg';
        this.noInternetAnimation = null;

        // set end Marker
        const noNetworkMarker = new google.maps.Marker({
          position: new google.maps.LatLng(
            location.latitude,
            location.longitude
          ),
          animation: google.maps.Animation.BOUNCE,
          map: this.eventVisibility.get('no-network-start') ? this.map : null,
          icon: 'assets/icons/no-network-end.svg',
          zIndex: 100,
        });

        this.addMarkerTooltip(
          noNetworkMarker,
          'Network Loss Ended',
          this.map,
          location.time
        );

        setTimeout(() => {
          noNetworkMarker.setAnimation(null);
        }, 100);

        this.mapControlService.noNetworkMarkerList.push(noNetworkMarker);
      }
    }

    // if (this.startNetworkLoss) {
    //   this.startNetworkLoss = false;
    //   const interval = this.networkLossIntervals.find(
    //     (interval) => interval[0] == location.time
    //   );

    //   // set start Marker
    //   const noNetworkMarker = new google.maps.Marker({
    //     position: new google.maps.LatLng(location.latitude, location.longitude),
    //     animation: google.maps.Animation.BOUNCE,
    //     map: this.map,
    //     icon: 'assets/icons/no-network-start.svg',
    //     zIndex: 100,
    //   });

    //   this.addMarkerTooltip(
    //     noNetworkMarker,
    //     'Network Loss Started',
    //     this.map,
    //     location.time
    //   );

    //   setTimeout(() => {
    //     noNetworkMarker.setAnimation(null);
    //   }, 100);

    //   this.mapControlService.noNetworkMarkerList.push(noNetworkMarker);

    //   const noInternetBusUrl = 'assets/icons/no-network-bus-on-map.svg';
    //   const busImage = 'assets/icons/bus-on-map.svg';

    //   this.noInternetAnimation = setInterval(() => {
    //     if (
    //       this.mapControlService.mapVehicleMarker.getIcon()['url'] === busImage
    //     ) {
    //       this.busImageURL = noInternetBusUrl;
    //     } else {
    //       this.busImageURL = busImage;
    //     }
    //   }, 500);
    // }
    this.plotNoShow(this.noShowInterval,location,indexMile)
    this.plotSignInLocationMarkers(location,indexMile)
    this.plotCallEmployeeMarkersOnMap(location);

    // Set vehicle stoppage
    if(this.vehicleStoppageIndexes?.length){
      this.vehicleStoppageIndexes.forEach((loc) => {
        if(indexMile>0 && loc.startTime>=this.locationList[indexMile-1].time && loc.startTime<this.locationList[indexMile].time){
          let vehicleStopageMarker = new google.maps.Marker({
            position: new google.maps.LatLng(location.latitude, location.longitude),
            map: this.eventVisibility.get('vehicle-stoppage') ? this.map : null,
            icon: 'assets/icons/vehicle-stoppage.svg',
            zIndex: 100,
          });
      
          const vehicleStoppageTooltipContent = `
            <div class="vehicle-stoppage-tooltip">
              <div>
              <h2>Vehicle Stoppage</h2>
              <p><span>Alert Status</span>: ${loc.status}</p>
              <p><span>Alert Type</span>: ${loc.alertSeverity}</p>
              <p><span>Duration </span>: ${DateUtils.formatTime(loc.startTime, "hh:mm")} : ${DateUtils.formatTime(loc.endTime, "hh:mm")}</p>
              <p><span>Set threshold value</span>: ${loc.thresholdvalue}</p>
              </div>   
            </div>
          `;
      
          const vehicleStoppageInfoWindow = new google.maps.InfoWindow({
            content: vehicleStoppageTooltipContent,
          });
      
          vehicleStopageMarker.addListener('click', () => {
            vehicleStoppageInfoWindow.open(this.map, vehicleStopageMarker);
          });
      
          this.map.addListener('click', () => {
            vehicleStoppageInfoWindow.close();
          });
      
          this.mapControlService.vehicleStoppageMarkerList.push(vehicleStopageMarker);
        }
      })
    }
    // Set SOS
    if (this.sosArrayRes.length) {
      this.sosArrayRes.forEach((loc) => {
        let currentInfoWindow: google.maps.InfoWindow | null = null;

        if(indexMile>0 && loc.time>=this.locationList[indexMile-1].time && loc.time<this.locationList[indexMile].time){
          const sosMarker = new google.maps.Marker({
            position: vehiclePosition,
            map: this.eventVisibility.get('sos') ? this.map : null,
            icon: 'assets/icons/sos.svg',
            zIndex: 102,
          });
    
          const tooltipContent = `
            <div class="sos-marker-tooltip">
              <div>
               <h2>SOS Raised</h2>
              <p><span>Alert Status</span>: ${loc.status}</p>
              <p><span>Alert Type</span>: ${loc.alertSeverity}</p>
              <p><span>Duration </span>: ${DateUtils.formatTime(loc.startTime, "hh:mm")} : ${DateUtils.formatTime(loc.endTime, "hh:mm")}</p>
              <p><span>Raised From</span>: ${loc.raisedFrom}</p>
              </div>    
            </div>
          `;

          const infoWindow = new google.maps.InfoWindow({
            content: tooltipContent,
          });
      sosMarker.addListener('click', () => {
        if (currentInfoWindow) {
          currentInfoWindow.close(); // Close the currently open InfoWindow
        }

        if (currentInfoWindow !== infoWindow) {
          infoWindow.open(this.map, sosMarker);
          currentInfoWindow = infoWindow; // Update the reference to the currently open InfoWindow
        } else {
          currentInfoWindow = null; // Clicked on the same marker, so close the InfoWindow
        }
      });

      this.map.addListener('click', () => {
        if (currentInfoWindow) {
          currentInfoWindow.close(); // Close the InfoWindow if clicking on the map
          currentInfoWindow = null;
        }
      });
    
          setTimeout(() => {
            sosMarker.setAnimation(null);
          }, 100);
    
          this.giveVehiclePause();
          this.mapControlService.sosMarkerList.push(sosMarker);
        }
      });
    }
      // Geofence Hitting call and emp pickup or drop
    if (
      this.geofenceHittedStops.get(
        location.latitude.toFixed(5) + ',' + location.longitude.toFixed(5)
      ) != undefined
    ) {
      const index = this.geofenceHittedStops.get(
        location.latitude.toFixed(5) + ',' + location.longitude.toFixed(5)
      );
      const currShuttleStop = this.tripDetails.shuttleStops[index];
      const shuttleStopPostion = new google.maps.LatLng(
        Number(currShuttleStop.geoCord.split(',')[0]),
        Number(currShuttleStop.geoCord.split(',')[1])
      );
      let type: string = 'on time';
      let infoWindowContent: string = ' on time';
      if (currShuttleStop.arrivalTimeDiff > 0) {
        type = 'late';
        infoWindowContent = ' late';
      }
      this.geofenceHittingCircle(shuttleStopPostion, type);

      const empAtStop = this.empPickupDropForStops.get(
        this.tripDetails.shuttleStops[index]['nativeId']
      );
      const currShuttleStopMarker =
        this.mapControlService.shuttleStopMarkerList[index];

      if (
        (this.tripDetails.direction === 'OUT' && index !== 0) ||
        (this.tripDetails.direction === 'IN' &&
          index !== this.tripDetails.shuttleStops.length - 1)
      ) {
        const newMarkerIcon = {
          url: 'assets/icons/map-emp-pickup.svg', // URL to your custom marker icon image
          scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
          labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
        };
        currShuttleStopMarker.setOptions({
          icon: newMarkerIcon,
          label: {
            text: index + 1 < 10 ? '0' + (index + 1) : '' + (index + 1),
            color: '#FFFFFF',
            fontSize: '14px', // Font size of the label (number)
            fontWeight: 'bold', // Font weight of the label (number)
          },
          zIndex: 101,
        });
      }
      this.showEmpPickupDrop(
        this.tripDetails.direction,
        currShuttleStopMarker,
        empAtStop
      );

      // OTA/OTD for 1st and last stop
      if (index == 0 || index == this.tripDetails.shuttleStops.length - 1) {
        const stop =
          this.tripDetails.direction === 'OUT'
            ? index == 0
              ? 'Office'
              : `Stop ${this.tripDetails.shuttleStops.length}`
            : index == 0
              ? 'Stop 1'
              : 'Office';
        const hours = Math.floor(
          DateUtils.convertMinutesToHours(currShuttleStop.arrivalTimeDiff)
        );
    
          const minutes = DateUtils.getMinutesFromDuration(currShuttleStop.arrivalTimeDiff);
        const delayedTime =
          currShuttleStop.arrivalTimeDiff > 0
            ? `(${hours ? hours + ' Hrs ' : ''}${minutes} mins)`
            : '';
        if (index == 0) {
          this.mapControlService.shuttleStopMarkerList[0].addListener(
            'click',
            () => {
              this.mapControlService.infoWindowList[0].open(
                this.map,
                this.mapControlService.shuttleStopMarkerList[0]
              );
            }
          );
        } else {
          this.mapControlService.shuttleStopMarkerList[
            this.tripDetails.shuttleStops.length - 1
          ].addListener('click', () => {
            this.mapControlService.infoWindowList[1].open(
              this.map,
              this.mapControlService.shuttleStopMarkerList[
              this.tripDetails.shuttleStops.length - 1
              ]
            );
          });
        }

      }

      this.giveVehiclePause();
    }

    // Plot overspeed plotline

    if (
      this.overspeedingIntervals.some(
        (interval) => {
          if(indexMile>0 && interval.startTime <= this.locationList[indexMile].time && interval.startTime > this.locationList[indexMile-1].time){
            this.currentOverSpeedData = interval;
            return true;
          } 
          else 
            return false;
        }
      )
    ) {
      this.startPlottingOverspeed = true;  
    }

    if (this.startPlottingOverspeed) {
      this.overspeedformattedWaypoints.push(
        new google.maps.LatLng(location.latitude, location.longitude)
      );
      if (this.deviceOffStart || this.gpsLossStart) {
        // add buffer
        this.mapControlService.overSpeedPolylineList.push(
          new google.maps.Polyline()
        );
        this.overspeedformattedWaypoints = [];
      }

      this.plottingPolyLine(
        this.map,
        this.startPlottingOverspeed,
        this.gpsLossStart
      );

      if (
        this.overspeedingIntervals.some(
        (interval) => {
          if(indexMile>0 && interval.endTime <= this.locationList[indexMile].time && interval.endTime > this.locationList[indexMile-1].time){
            this.currentOverSpeedData = interval;
            return true;
          } 
          else 
            return false;
        }
      ) 
      ){
        this.startPlottingOverspeed = false;
        this.overspeedformattedWaypoints = [];
        this.mapControlService.overSpeedPolylineList.push(
          new google.maps.Polyline()
        );
        this.currentOverSpeedData=null;
      }
    }

    // set polyline

    this.formattedWaypoints.push(
      new google.maps.LatLng(location.latitude, location.longitude)
    );
    if (this.deviceOffStart || this.gpsLossStart) {
      // add buffer
      this.mapControlService.polylineList.push(new google.maps.Polyline());
      this.formattedWaypoints = [];
    }
    this.plottingPolyLine(
      this.map,
      this.startPlottingOverspeed,
      this.gpsLossStart
    );

    // Moving Vehicle
    const bearing = location?.mBearing;
    let current = { lat: location.latitude, lng: location.longitude };
    if (this.indexForMilestone != 0) {
      this.animatedMove(
        this.mapControlService.mapVehicleMarker,
        this.vehiclePreviousCoords,
        current,
        bearing
      );
    }
    this.vehiclePreviousCoords = current;
  }

  addMarkerTooltip(
    marker: google.maps.Marker,
    title: string,
    map: google.maps.Map,
    time: number
  ): void {
    const tooltip = new google.maps.InfoWindow({
      content: `
              <div class="ota-otd-infobox">
                <div><b>${title}</b></div>
                <div class='time'>${DateUtils.formatTime(time, 'hh:mm')}</div>
              </div>`,
    });

    marker.addListener('click', () => {
      tooltip.open(map, marker);
    });
  }

  showEmpPickupDrop(
    tripDirection: string,
    shuttleMarker: google.maps.Marker,
    empAtStop: number
  ) {
    if (empAtStop != 0) {
      let yPosition = 0;
      const texOverlay = new google.maps.Marker({
        position: shuttleMarker.getPosition(),
        map: this.map,
        icon: {
          url: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
          anchor: new google.maps.Point(-30, yPosition),
        },
        label: {
          className: 'emp-pickup-text',
          color: '#638fe7',
          fontWeight: 'bold',
          text: `${tripDirection === 'OUT' ? '-' : '+'}${empAtStop}`,
          fontSize: '32px',
        },
        opacity: 0,
      });

      const openAnimation = setInterval(() => {
        if (texOverlay.getOpacity() > 1) {
          texOverlay.setOpacity(1);
          clearInterval(openAnimation);

          setTimeout(() => {
            const closeAnimation = setInterval(() => {
              if (texOverlay.getOpacity() < 0) {
                texOverlay.setOpacity(0);
                clearInterval(closeAnimation);
              } else {
                texOverlay.setOpacity(texOverlay.getOpacity() - 0.1);
              }
              yPosition += 3;
              texOverlay.setIcon({
                url: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
                anchor: new google.maps.Point(-30, yPosition),
              });
            }, 20);
          }, 1500);
        } else {
          texOverlay.setOpacity(texOverlay.getOpacity() + 0.1);
        }
        yPosition += 3;
        texOverlay.setIcon({
          url: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
          anchor: new google.maps.Point(-30, yPosition),
        });
      }, 30);
    }
  }

  calcPickupDropEmpsForStops() {
    const shuttleStops = this.tripDetails.shuttleStops;
    const employees = this.tripDetails.employees;
        shuttleStops.forEach((stop, index) => {
      this.empPickupDropForStops.set(stop.nativeId, 0);
      if (stop.actualArrivalGeoCode != null && !stop.skipped) {
        const [latStr, lngStr] = stop.actualArrivalGeoCode.split(',');
        const normalizedKey =
        parseFloat(latStr).toFixed(5) + ',' + parseFloat(lngStr).toFixed(5);
        this.geofenceHittedStops.set(normalizedKey, index);
      }
    });

    console.log(this.geofenceHittedStops);

    for (let employee of employees) {
      if (this.tripDetails.direction === 'OUT') {
        // Check if no show
        if (employee.actualDropLocation) {
          this.empPickupDropForStops.set(
            employee.actualDropLocation.locationId,
            this.empPickupDropForStops.get(
              employee.actualDropLocation.locationId
            ) + 1
          );
        } else {
          console.log('no show || no signin for ' + employee.employeeId);
        }
      } else {
        // Check if no show
        if (employee.actualPickupLocation) {
          this.empPickupDropForStops.set(
            employee.actualPickupLocation.locationId,
            this.empPickupDropForStops.get(
              employee.actualPickupLocation.locationId
            ) + 1
          );
        } else {
          console.log('no show || no signin for ' + employee.employeeId);
        }
      }
    }
    
    console.log(this.empPickupDropForStops);
  }

  showPlannedRoute() {
    this.plannedRouteToggle = !this.plannedRouteToggle;
    this.plotPlannedRoute();
  }

  plotPlannedRoute() {
    const shuttleStops = this.tripDetails.shuttleStops;
    let routeConfig = [];
    shuttleStops.forEach((stop) => {
      const lat = stop.geoCord.split(',')[0];
      const lng = stop.geoCord.split(',')[1];
      routeConfig.push({ lat: +lat, lng: +lng });
    });

    this.calculateRoute(routeConfig);
  }

  calculateRoute(coOr) {
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer({
      map: this.map,
    });
    for (let i = 1; i < coOr.length; i++) {
      const request = {
        origin: coOr[i - 1], // Start point
        destination: coOr[i], // End point
        travelMode: google.maps.TravelMode.DRIVING, // Use driving directions
      };
      const _this = this;
      // Request the directions
      directionsService.route(request, function (response, status) {
        if (status === google.maps.DirectionsStatus.OK) {
          _this.draw(response.routes[0].legs, directionsRenderer, response);
        }
      });
    }
  }
  draw(legs, directionsRenderer, res) {
    for (let i = 0; i < legs.length; i++) {
      const steps = legs[i].steps;

      for (let j = 0; j < steps.length; j++) {
        const polyline = new google.maps.Polyline({
          path: steps[j].path,
          strokeColor: '#FF9A22',
          strokeOpacity: 0,
          zIndex: 100,
          icons: [
            {
              icon: {
                path: 'M 0,-1 0,1', // set length this is (0,-1) to (0,1)
                strokeWeight: 2,
                strokeOpacity: 1,
                scale: 3,
              },
              offset: '0',
              repeat: '15px', // Set the distance between dashes
            },
          ],
          map: this.map,
        });
        this.mapControlService.plannedPolylineList.push(polyline);
      }
      // Fix invalid property value error
      // console.log("legs",legs)
      // directionsRenderer.setDirections(legs);
    }
  }

  plotMarkers() {
    const shuttleStops = this.newShuttleStops;
    for (let i = 0; i < shuttleStops.length; i++) {
      var data = {
        plannedEmployees: shuttleStops[i].employees,
        unplannedEmployees: shuttleStops[i].unPlannedEmployeesOnStop,
        address: shuttleStops[i].address,
        actualArrivalTimeOfStop: DateUtils.formatTimeWithZone(shuttleStops[i].actualArrivalTime || this.tripDetails.actualEndTime, this.commonService.timeZone, "HH:mm"),
        plannedArrivalTimeOfStop: DateUtils.formatTimeWithZone(shuttleStops[i].plannedArrivalTime, this.commonService.timeZone, "HH:mm"),
          localityId: shuttleStops[i].localityId,
        isOffice : false
      };

      if(this.tripDetails.direction === 'OUT'){
        data['isOffice'] = i === 0
      }
      else {
        data['isOffice'] = i === shuttleStops.length - 1
      }
      console.log(data);
      let url: string;
      let labelText: string;
      let labelColor: string;

      // Define marker icons and labels based on shuttle stop position
      if (i === 0 && this.tripDetails.direction === 'OUT') {
        url = `${this.imgSrc}assets/icons/logout-office.svg`;
        labelText = ' ';
        labelColor = '#FFFFFF';
      } else if (i === shuttleStops.length - 1 && this.tripDetails.direction === 'IN') {
        url = `${this.imgSrc}assets/icons/office-marker.svg`;
        labelText = ' ';
        labelColor = '#FFFFFF';
      } else {
        url = `${this.imgSrc}assets/icons/bus-stop-missed-icon.svg`;
        labelText = i + 1 < 10 ? '0' + (i + 1) : '' + (i + 1);
        labelColor = '#6A737D';
      }

      const markerIcon = {
        url: url, 
        scaledSize: new google.maps.Size(60, 60), 
        labelOrigin: new google.maps.Point(30, 20), 
      };

      const lat = shuttleStops[i].geoCord.split(',')[0];
      const lng = shuttleStops[i].geoCord.split(',')[1];
      const position = new google.maps.LatLng(lat, lng);

      // Create the marker
      let marker = new google.maps.Marker({
        position: position,
        map: this.map,
        icon: markerIcon,
        animation: this.firstTimePlottingMarker ? google.maps.Animation.DROP : null,
        zIndex: 101,
        label: {
          text: labelText, 
          color: labelColor, 
          fontSize: '14px', 
          fontWeight: 'bold', 
        },
      });

      const imgElement = document.createElement('img');
      if(this.tripDetails.actualEndTime == this.tripDetails.plannedEndTime){
        imgElement.src = `${this.imgSrc}assets/icons/time_chip_ontime.png`; // Set the path to your PNG image
      }
      else if(this.tripDetails.actualEndTime < this.tripDetails.plannedEndTime){
        imgElement.src = `${this.imgSrc}assets/icons/time_chip_early.png`; // Set the path to your PNG image
      }
      else{
        imgElement.src = `${this.imgSrc}assets/icons/time_chip_delayed.png`; // Set the path to your PNG image
      }
      imgElement.style.position = 'absolute'; // Required to position it on the map

      const overlay = new google.maps.OverlayView();

      overlay.onAdd = () => {
      const panes = overlay.getPanes();
      panes.overlayMouseTarget.appendChild(imgElement); // Append the img element to the overlay
      };

      overlay.draw = () => {
      const projection = overlay.getProjection();
      const position = projection.fromLatLngToDivPixel(marker.getPosition());

      if (position) {
        imgElement.style.left = `${position.x - imgElement.offsetWidth / 2}px`; // Center horizontally
        imgElement.style.top = `${position.y}px`; // Adjust to place the PNG exactly below the marker
      }
      };
if(data.isOffice){
  overlay.setMap(this.map);
}

      marker.set('data', data);
      this.mapControlService.shuttleStopMarkerList.push(marker);

      marker.addListener('click', () => {
        if(this.clickedMarker?.['data'].isOffice){
          this.otaOtdData=true;
        }
        else{
          this.otaOtdData=false;
        }
        if (this.clickedMarker === marker) {
          this.toggleDivComponent(!this.enableEmployeesDetails);
        } else {
          this.clickedMarker = marker;
          this.updateShuttleStopData(this.clickedMarker['data']);
          this.toggleDivComponent(true); // Ensure the div is shown
        }
      });
      this.firstTimePlottingMarker = false;
    }
  }

  toggleDivComponent(isVisible: boolean) {
    this.enableEmployeesDetails = isVisible;
  }

  updateShuttleStopData(shuttleStop: any) {
    this.selectedShuttleStop = shuttleStop;
  }
  onClosePopup(event){
    this.enableEmployeesDetails = false;
  }

  plottingPolyLine(map: any, isOverspeeding: boolean, isGPSLoss: boolean) {
    if (this.mapControlService.polylineList.length > 0) {
      this.mapControlService.polylineList.pop().setMap(null);
    }
    this.polyline = new google.maps.Polyline({
      path: this.formattedWaypoints,
      geodesic: true,
      strokeColor: '#4F5694',
      strokeOpacity: 1.0,
      strokeWeight: 4,
      zIndex: 98,
    });
    this.mapControlService.polylineList.push(this.polyline);
    this.polyline.setMap(map);

    if (isOverspeeding) {
      if (this.mapControlService.overSpeedPolylineList.length > 0) {
        this.mapControlService.overSpeedPolylineList.pop().setMap(null);
      }
      const overSpeedPolyLine = new google.maps.Polyline({
        path: this.overspeedformattedWaypoints,
        geodesic: true,
        strokeColor: '#ED323B',
        strokeOpacity: 1.0,
        strokeWeight: 7,
        zIndex: 99,
      });
      this.mapControlService.overSpeedPolylineList.push(overSpeedPolyLine);
      overSpeedPolyLine.setMap(this.eventVisibility.get('over-speeding') ? map : null);
    
      this.polylineAnimationList.forEach((animation) =>
        clearInterval(animation)
      );
    
      const polylineAnimation = setInterval(() => {
        if (this.increasing) {
          this.strokeWidth += 1;
          if (this.strokeWidth >= this.maxStrokeWidth) {
            this.increasing = false;
          }
        } else {
          this.strokeWidth -= 1;
          if (this.strokeWidth <= 2) {
            this.increasing = true;
          }
        }
        this.mapControlService.overSpeedPolylineList.forEach((poly) => {
          poly.setOptions({ strokeWeight: this.strokeWidth });
        });
      }, 100);
      this.polylineAnimationList.push(polylineAnimation);
    
      // Tooltip for overspeeding polyline
      const overSpeedTooltipDiv = document.createElement('div');
      overSpeedTooltipDiv.style.position = 'absolute';
      overSpeedTooltipDiv.style.display = 'none'; // Initially hidden
      overSpeedTooltipDiv.style.pointerEvents = 'none'; // Prevent interference with mouse events
      overSpeedTooltipDiv.innerHTML = `
        <div class="overspeed-poly-tooltip">
          <div>
            <h2>Overspeeding</h2>
            <p><span>Alert Status: </span>${this.currentOverSpeedData.status}</p>
            <p><span>Alert Type: </span>${this.currentOverSpeedData.alertSeverity}</p>
            <p><span>Duration: </span> ${DateUtils.formatTime(this.currentOverSpeedData.startTime, "hh:mm")} : ${DateUtils.formatTime(this.currentOverSpeedData.endTime, "hh:mm")} </p>
            <p><span>Set Threshold: </span>${this.currentOverSpeedData.thresholdValue} kmph</p>
          </div>
        </div>
      `;
      document.body.appendChild(overSpeedTooltipDiv);
    
      overSpeedPolyLine.addListener('mouseover', (event) => {
        overSpeedTooltipDiv.style.display = 'block'; // Show tooltip on hover
      });
    
      overSpeedPolyLine.addListener('mousemove', (event) => {
        const projection = map.getProjection();
        const point = projection.fromLatLngToPoint(event.latLng);
    
        const scale = Math.pow(2, map.getZoom());
        const worldCoordinate = new google.maps.Point(
          point.x * scale,
          point.y * scale
        );
    
        overSpeedTooltipDiv.style.left = `${event.domEvent.clientX + 10}px`;
        overSpeedTooltipDiv.style.top = `${event.domEvent.clientY + 10}px`;
      });
    
      overSpeedPolyLine.addListener('mouseout', () => {
        overSpeedTooltipDiv.style.display = 'none'; // Hide tooltip when the mouse leaves the polyline
      });
    }
    

    if (isGPSLoss) {
    // Create your polyline
    console.log("way",this.gpsLossWaypoints)
    const gpsLossPolyline = new google.maps.Polyline({
      path: this.gpsLossWaypoints,
      geodesic: true,
      strokeColor: '#354052',
      strokeOpacity: 1.0,
      strokeWeight: 9,
      zIndex: 99,
    });

    // currently not working on gps tool tip . can be used later
    // // Create the custom div component
    // const tooltipDiv = document.createElement('div');
    // tooltipDiv.style.position = 'absolute';
    // tooltipDiv.style.display = 'none'; // Initially hidden
    // tooltipDiv.style.pointerEvents = 'none'; // Prevent interference with mouse events
    // tooltipDiv.innerHTML = `
    //   <div class="gps-loss-poly-tooltip">
    //   <div>
    //   <h2>GPS Loss</h2>
    //   </div>
    //   </div>
    // `;
    // document.body.appendChild(tooltipDiv);
    // gpsLossPolyline.addListener('mouseover', (event) => {
    //   tooltipDiv.style.display = 'block';
    // });

    // gpsLossPolyline.addListener('mousemove', (event) => {
    //   const projection = map.getProjection();
    //   const point = projection.fromLatLngToPoint(event.latLng);

    //   const scale = Math.pow(2, map.getZoom());
    //   const worldCoordinate = new google.maps.Point(
    //     point.x * scale,
    //     point.y * scale
    //   );

    //   tooltipDiv.style.left = `${event.domEvent.clientX + 10}px`;
    //   tooltipDiv.style.top = `${event.domEvent.clientY + 10}px`;
    // });

    // gpsLossPolyline.addListener('mouseout', () => {
    //   tooltipDiv.style.display = 'none'; // Hide the tooltip when the mouse leaves the polyline
    // });

    this.mapControlService.gpsLossPolylineList.push(gpsLossPolyline);
    gpsLossPolyline.setMap(map);
    }
  }

  async animatedMove(
    marker: any,
    current: { lat: any; lng: any },
    moveto: { lat: number; lng: number },
    bearing: any
  ) {
    if (!marker || !isValidCoordinate(current.lat, current.lng) || !isValidCoordinate(moveto.lat, moveto.lng)) return;
    var imgIcon = marker.getIcon?.();
    if(imgIcon) {
      imgIcon.url = this.busImageURL;
      imgIcon.rotation = bearing;
      marker.setIcon(imgIcon);
    }
    var nxlat = moveto.lat;
    var nxlng = moveto.lng;
    var deltalat = (moveto.lat - current.lat) / 100;
    var deltalng = (moveto.lng - current.lng) / 100;
    for (var i = 0; i < 100; i++) {
      (function (ind) {
        setTimeout(function () {
          var newLat = marker.position.lat();
          var newLng = marker.position.lng();
          newLat += deltalat;
          newLng += deltalng;

          marker.setPosition({ lat: newLat, lng: newLng });
        }, 1 * ind);
      })(i);
    }
    marker.setValues({ lat: nxlat, lng: nxlng });
    let elemSel = document.querySelector(
      'img[src*="bus-on-map.svg"]'
    ) as HTMLElement;
    if (elemSel && bearing != null && bearing != 0) {
      elemSel.style.transform = `rotate(${bearing}deg)`;
    }
  }

  giveVehiclePause() {
    clearInterval(this.mapControlService.tripInterval);
    const pauseTimeout = setTimeout(() => {
      this.startTrip();
    }, 1000);
    this.mapControlService.timeoutSet.push(pauseTimeout);
  }

  mapInitializer() {
    this.map = new google.maps.Map(
      document.getElementById('map') as HTMLElement,
      this.mapOptions
    );

    this.mapControlService.map = this.map;
    
    this.geofenceRendererService.initialize(this.map);
    
    if (this.tripDetails?.['geofences']) {
      this.geofenceRendererService.plotGeofencePoints(this.tripDetails?.['geofences'] ?? {});
    }
    
    if (this.tripDetails?.['virtualWayPoints']) {
      this.geofenceRendererService.plotVirtualWayPoints(this.tripDetails?.['virtualWayPoints']??{});
    }
  }
  selectedValue(value) {
    switch (value) {
      case 'Fixed Device':
        // this.selectedRadioValue = "FIXED_DEVICE";
        this.commonService.driverFixedDevice = true;
        this.reStart.emit()
        // this.getTrackingSession()
        break;
      case 'Driver App':
        // this.selectedRadioValue = 'MOBILE';
        this.commonService.driverFixedDevice = false;
        this.reStart.emit()
        // this.getTrackingSession()
        break;
      default:
        break;
    }
  }

  ngOnDestroy() {
    this.clearEventLoops();
    this.startCallSubscription && this.startCallSubscription.unsubscribe();
    this.filterChangeSubscription &&
      this.filterChangeSubscription.unsubscribe();
    this.mapLoaderSubscription && this.mapLoaderSubscription.unsubscribe();
    this.restartCallSubscription && this.restartCallSubscription.unsubscribe();
    this.locationListSubscription &&
      this.locationListSubscription.unsubscribe();
  }
}
